// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"292":"0acc6e5c","689":"bcfe6f15"}[chunkId] + ".chunk.css";
};